import React, { createContext, useCallback, useContext, useState } from 'react';

interface DarkModeData {
  isDark: boolean;
  toggleDarkMode(): void;
}

export const DarkModeContext = createContext<DarkModeData>({} as DarkModeData);

export const DarkModeProvider: React.FC = ({ children }) => {
  const [isDark, setIsDark] = useState<boolean>(() => {
    const isDark = localStorage.getItem('@eBov:isDark');

    if (isDark) {
      return isDark === 'true';
    } else {
      return false;
    }
  });

  const toggleDarkMode = useCallback(() => {
    setIsDark(!isDark);

    localStorage.setItem('@eBov:isDark', (!isDark).toString());
  }, [isDark, setIsDark]);

  return (
    <DarkModeContext.Provider
      value={{
        isDark,
        toggleDarkMode,
      }}
    >
      {children}
    </DarkModeContext.Provider>
  );
};

export function useDarkMode(): DarkModeData {
  const context = useContext(DarkModeContext);

  if (!context) {
    throw new Error('Context must be used within a ContextProvider');
  }
  return context;
}
